<template lang="pug">
#snap-drawers.snap-drawers
  .snap-drawer.snap-drawer-left
    .fixed-nav
      #nav-search.searchbar
        a(href='javascript:void(0);' @click="open()")
          span.icon
            i.fad.fa-search
          span {{ $t("ui.search_team") }}
    ul
      li
        router-link(to="/tournament" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
          img.mb-2(src='/images/icon-other/tournament_tag.gif?v=12')
      //- li
      //-   a(href='javascript:void(0);' @click='setMenu0("2", getEventDate("2024-06-14T21:00:00"))')
      //-     span.snap-icon
      //-       img(src='/images/icon-other/euro24.png?v=12')
      //-     span.snap-text {{ $t("ui.event_euro") }}
      //- li
      //-   a(href='javascript:void(0);' @click='setMenu0("1", getEventDate("2024-06-14T21:00:00"))')
      //-     span.snap-icon
      //-       img(src='/images/icon-other/copa24.png?v=12')
      //-     span.snap-text {{ $t("ui.event_copa") }}
      //- li
      //-   a(href='javascript:void(0);' @click='setMenu0("4", getEventDate("2024-06-14T21:00:00"))')
      //-     span.snap-icon
      //-       img(src='/images/icon-other/olympic24.png?v=12')
      //-     span.snap-text {{ $t("ui.event_olympic") }}
      li
        a(href='javascript:void(0);' @click="go()")
          span.snap-icon
            img(src='/images/icon-sport-svg/all.svg?v=12')
          span.snap-text {{ $t("ui.my_sports") }}
      li(v-if="!whiteLabel && esports2")
        router-link(to="/slots?mode=3" target="_blank" onclick="window.open(this.href,'esports2','status=no,toolbar=no,menubar=no,location=no');return false;")
          span.snap-icon
            img(src='/images/icon-sport-svg/20.svg?v=12')
          span.snap-text {{ $t("ui.esports2") }}
      li(v-if="!mmoMode && !brand && !thaiBrand")
        router-link(to="/w4d" target="_blank" onclick="window.open(this.href,'w4d','status=no,toolbar=no,menubar=no,location=no');return false;")
          span.snap-icon
            img(src='/images/icon-other/lottery-icon.svg?v=12')
          span.snap-text {{ $t("ui.w4d") }}
      li
        a(href="javascript:void(0);" @click='setMenu2x(43)')
          span.snap-icon
            img(src='/images/icon-other/v-games.svg?v=12')
          span.snap-text {{ $t("ui.egames") }}
      //- li
      //-   router-link(to="/tournament" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
      //-     span.snap-icon
      //-       img(src='/images/icon-other/tournament.png?v=12')
      //-     span.snap-text {{ $t("ui.tournament") }}
      template(v-if="!mmoMode && ['MYR', 'THB', 'USD', 'MMK', 'MMO', 'CNY', 'IDR', 'SGD'].includes($store.getters.currencyCode)")
        li
          router-link(to="/slots?mode=10" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
            span.snap-icon
              img(src='/images/icon-other/slot-dbhash.png?v=12')
            span.snap-text {{ $t("ui.poker_db") }}
      li
        a(data-toggle='collapse' href='#casino' role='button' aria-expanded='true' aria-controls='casino')
          span.snap-icon.nav-sub-menu
            img(src='/images/icon-other/casino-icon.svg?v=12')
          span.snap-text {{ $t("ui.casino") }}
      li#casino.sub-menu.active.collapse.show
        ul
          //- li(v-if="!mmoMode && ['MYR', 'SGD', 'THB', 'VND', 'IDR', 'CNY', 'USD'].includes($store.getters.currencyCode)")
          //-   router-link(to="/casino?suite=10" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
          //-     span.snap-icon
          //-       img(src='/images/icon-other/slot-ppg.png?v=12')
          //-     span.snap-text {{ $t("ui.suite_pp-c") }}
          //- li(v-if="!mmoMode")
          //-   router-link(to="/casino?suite=11" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
          //-     span.snap-icon
          //-       img(src='/images/icon-other/casino_ai.png?v=12')
          //-     span.snap-text {{ $t("ui.suite_ai") }}
          li
            router-link(to="/casino?suite=9" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
              span.snap-icon
                img(src='/images/icon-other/suite_yb_icon.png?v=12')
              span.snap-text {{ $t("ui.suite_yb") }}
          li(v-if="!brand")
            router-link(to="/casino?suite=4" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
              span.snap-icon
                img(src='/images/icon-other/suite_ct_icon.png?v=12')
              span.snap-text {{ $t("ui.suite_ct855") }}
          li(v-if="!mmoMode")
            router-link(to="/casino?suite=1" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
              span.snap-icon
                img(src='/images/icon-other/suite_gp_icon.png?v=12')
              span.snap-text {{ $t("ui.suite_gp") }}
          li(v-if="!brand")
            router-link(to="/casino?suite=3" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
              span.snap-icon
                img(src='/images/icon-other/suite_sa_icon.png?v=12')
              span.snap-text {{ $t("ui.suite_sa") }}
          li(v-if="!mmoMode && !brand")
            router-link(to="/casino?suite=8" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
              span.snap-icon
                img(src='/images/icon-other/suite_ev_icon.png?v=12')
              span.snap-text {{ $t("ui.suite_evo") }}
          li(v-if="!mmoMode")
            router-link(to="/casino?suite=7" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
              span.snap-icon
                img(src='/images/icon-other/suite_pg_icon.png?v=12')
              span.snap-text {{ $t("ui.suite_pg") }}
      template
        li
          a(data-toggle='collapse' href='#slot' role='button' aria-expanded='true' aria-controls='casino')
            span.snap-icon.nav-sub-menu
              img(src='/images/icon-other/slot-icon.svg?v=12')
            span.snap-text {{ $t("ui.slots") }}
        li#slot.sub-menu.active.collapse.show
          ul
            template(v-if="['SGD', 'CNY', 'IDR', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=12" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-wf.png?v=12')
                  span.snap-text {{ $t("ui.slot_wf") }}
            //- template(v-if="['SGD', 'CNY', 'IDR', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)")
            //-   li
            //-     router-link(to="/slots?mode=11" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
            //-       span.snap-icon
            //-         img(src='/images/icon-other/slot-wow.png?v=12')
            //-       span.snap-text {{ $t("ui.slot_wow") }}
            li
              router-link(to="/slots?mode=0" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                span.snap-icon
                  img(src='/images/icon-other/slot-live22.png?v=12')
                span.snap-text {{ $t("ui.slot_live22") }}
            template(v-if="['SGD', 'CNY', 'IDR', 'VND', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=7" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-uusl.png?v=12')
                  span.snap-text {{ $t("ui.slot_uusl") }}
            template(v-if="!mmoMode && ['MYR', 'THB', 'USD', 'MMK', 'MMO', 'CNY', 'IDR', 'SGD'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=9" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-dbhash.png?v=12')
                  span.snap-text {{ $t("ui.slot_dbhash") }}
            template(v-if="!['MYR','SGD'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=1" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-pgs.png?v=12')
                  span.snap-text {{ $t("ui.slot_pgs") }}
            template(v-if="['SGD', 'CNY', 'IDR', 'MYR', 'THB', 'USD', 'MMK', 'MMO'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=8" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-next.png?v=12')
                  span.snap-text {{ $t("ui.slot_next") }}
            template(v-if="!mmoMode && ['MYR', 'SGD', 'THB', 'VND', 'IDR', 'CNY', 'USD'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=2" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-ppg.png?v=12')
                  span.snap-text {{ $t("ui.slot_ppg") }}
            template(v-if="!mmoMode && ['MYR', 'THB', 'IDR', 'CNY', 'USD'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=4" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-jkr.png?v=12')
                  span.snap-text {{ $t("ui.slot_jkr") }}
            template(v-if="!mmoMode && ['CNY', 'IDR', 'THB', 'MYR', 'USD', 'SGD', 'VND'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=5" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-spp.png?v=12')
                  span.snap-text {{ $t("ui.slot_spp") }}
            template(v-if="!mmoMode && ['MYR', 'THB', 'USD'].includes($store.getters.currencyCode)")
              li
                router-link(to="/slots?mode=6" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
                  span.snap-icon
                    img(src='/images/icon-other/slot-jili.png?v=12')
                  span.snap-text {{ $t("ui.slot_jili") }}
      //- li(v-if="!mmoMode")
      //-   a(href="javascript:void(0);" data-toggle='modal' data-target='#minigame' @click="hide()")
      //-     span.snap-icon
      //-       img(src='/images/icon-other/miniarcade.png?v=12')
      //-     span.snap-text {{ $t("ui.mini_arcade") }}      
    .btn-lobby
      a(href='javascript:void(0);' @click="close()")
        span.icon
          i.fad.fa-sign-out
        span {{ $t("ui.back_to_lobby") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import ClickOutside from "vue-click-outside";
import config from "@/config";

export default {
  directives: {
    ClickOutside
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    esports2() {
      return config.esports2 == "1";
    },
    brand() {
      return config.brand == "IBCBET";
    },
    thaiBrand() {
      return config.brand == "UBETT";
    },
    search() {
      return this.$store.getters.search;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    resetSelectLeague() {
      this.$store.dispatch("layout/resetSelectLeague");
    },
    open() {
      $("#search-modal").fadeIn();
    },
    close() {
      if(this.$route.path != '/lobby') {
        $("body").removeClass("snapjs-left");
        this.$router.push("/lobby").catch(err => {});
      }
    },
    go() {
      if(this.$route.path != '/prematch') {
        this.$router.push("/prematch").catch(err => {});
      }
      $("body").removeClass("snapjs-left");
      $("#allsports").modal("show");
    },
    setMenu2x(mode) {
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = "all";
      mi5["menu1"] = "today";
      mi5["menu2"] = parseInt(mode);
      mi5["menu3"] = "hdpou";

      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE");
      if(this.$route.path != '/prematch') {
        this.$router.push("/prematch").catch(err => {});
      }
      $("body").removeClass("snapjs-left");
    },
    setMenu0(e, m, bt) {
      $("body").removeClass("snapjs-left");
      if (EventBus.setMenu0) {
        if(bt == 'orz') {
          EventBus.setMenu0('event', e, m, bt);
        } else {
          EventBus.setMenu0('event', e, m);
        }
      }

      // var mi5 = {};
      // mi5["menuX"] = false;
      // mi5["menuY"] = event;
      // mi5["menu0"] = "event";
      // mi5["menu1"] = market == null ? "today" : market;
      // mi5["menu2"] = parseInt(mode);
      // mi5["menu3"] = "hdpou";
      // var options = {};
      // options[mi5["menu2"]] = true;
      // this.$store.dispatch("layout/setMenuItems", mi5);
      // EventBus.$emit("INVALIDATE");
      // this.$router.push("/prematch");
    },
    getEventDate(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? "today" : "early";
    },
    getEventDate2(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? null : "orz";
    },
  }
};
</script>